import React, { useState } from "react";
import { DialogIcon, SidebarIcon, WandMagicIcon } from "../../../assets/images/svg";
import { useSelector, useDispatch } from "react-redux";
import { createChatSession, openChatSession } from "../redux/AISagas";
import Button from "../../../components/form/button/button";
import { Tooltip } from "react-tooltip";

const Sidebar = () => {
  const dispatch = useDispatch();
  const conversations = useSelector((state) => state.ai.conversations);
  const { id } = useSelector((state) => state.ai.currentSession);

  const [isExpanded, setIsExpanded] = useState(true);
  const handleNewChat = () => dispatch(createChatSession());
  const toggleSidebar = () => setIsExpanded((prev) => !prev);
  const handleOpenChat = (item) => dispatch(openChatSession(item));

  return (
    <div className={`sidebar ${isExpanded ? "" : "sidebar--collapsed"}`} data-testid="sidebar">
      <div className="sidebar__header">
        <Button
          icon={WandMagicIcon}
          text={isExpanded ? "New chat" : ""}
          variant={isExpanded ? "default" : "icon-only"}
          onClick={handleNewChat}
        />
        <SidebarIcon
          className="sidebar__toggle"
          onClick={toggleSidebar}
          data-testid="sidebar-toggle"
        />
      </div>

      {isExpanded && (
        <div className="sidebar__content">
          {Object.entries(conversations).map(([summary, conversation]) => (
            <div key={summary} className="sidebar__section">
              <p className="sidebar__section-title">{summary}</p>
              {conversation.map((item) => {
                const isActive = item.id === id;
                return (
                  <div
                    key={item.id}
                    className={`sidebar__item ${isActive ? "active" : ""}`}
                    onClick={() => {
                      if (item.id === id) return;
                      handleOpenChat(item);
                    }}
                  >
                    <DialogIcon className="sidebar__item-icon" />
                    <div
                      className="sidebar__item-text"
                      data-tooltip-id="sidebar-tooltip"
                      data-tooltip-content={item.summary}
                    >
                      {item.summary}
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      )}

      <Tooltip id="sidebar-tooltip" />
    </div>
  );
};

export default Sidebar;
